export default String.raw`
<div class="customer-submenu">
    <div class="customer-submenu__header">
        {{translations.WM}}
    </div>
    {% if customer.CompanyErpId <= 0 -%}
        <div class="no-data">{{ translations.AccessDenied }}</div>
    {% else %}
    <div class="eshop__table-container products erp-data-js" style="display: none" data-template="partials/customer-profile/wm/wm-details.html">
        <table>
            <colgroup>
                <col style="width:120px">
                <col style="width:140px">
                <col style="width:150px">
            </colgroup>
            <div class="erp-orders-tab">
                <label for="dateTo">{{ translations.WMFromLast3MonthsTo }}:</label>
                <input id="dateTo" class="form__input-value get-erp-data-js" type="date" name="dateTo" >
            </div>
            <thead>
                <tr>
                    <th class="id">{{ translations.Number | Capitalize }}</th>
                    <th>{{ translations.BuyDate }}</th>
                    <th>{{ translations.ReleaseDate }}</th>
                    <th>{{ translations.Stock }}</th>
                </tr>
            </thead>
            <div class="table-js" data-sp="CDN.eshop_GetWMs">
                <tbody>
                    <tr tabindex="0" class="row can-hover load-erp-wm-details-js parent-container-reload-js" data-url="{{ page.Url }}?&deeper-lvl=true&erp-data=true&wm-erp=true" rv-each-o="List">
                        <td class="id" rv-data-id="o.Id">{ o.ERPWMNumber }</td>
                        <td>{ o.Date | date }</td>
                        <td>{ o.ReleaseDate | date }</td>
                        <td>{ o.Warehouse }</td>
                    </tr>
                </tbody>
            </div>
        </table>
        <div class="no-data">{{ translations.NoWMs }}</div>
        {% include 'partials/customer-profile/pagination.html' -%}
    </div>
    <div class="loader-js loader big"></div>
    {% endif -%}
</div>
`